import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Wrapper = styled.div<{ $mb: boolean }>`
    display: flex;
    align-items: start;

    ${(props) => props.$mb && 'margin-bottom: 16px;'}

    &:last-child {
        margin-bottom: 0px;
    }
`

export const TitleWraper = styled.div``

export const Title = styled.div`
    color: ${(props) => props.theme.color.g500};
    ${(props) => props.theme.typo.displayXS}
    ${(props) => props.theme.fontWeight.medium};
`

export const Description = styled.div`
    color: ${(props) => props.theme.color.g400};
    ${(props) => props.theme.typo.bodyS}
    ${(props) => props.theme.fontWeight.regular};
`

export const Icon = styled(ImageBase)`
    margin-right: 8px;
    max-width: 30px;
`

export const Link = styled(LinkBase)`
    text-decoration: none;
    margin-bottom: 16px;
    padding: 8px;
    border-radius: 8px;
    display: block;

    &:last-child {
        margin-bottom: 0px;
    }

    &:hover,
    &:focus {
        background-color: ${(props) => props.theme.color.g100};
    }
`
